import axiosInstance from "@/config/axios";

interface BoardParams {
	skip?: number;
	limit?: number;
	companyId?: string;
	obligationType?: string;
	yearly?: number;
	startYear?: number;
	endYear?: number;
}
interface taxParamsDetails {
	companyId?: string;
	obligationType?: string;
	yearly?: number;
}
interface DividendParams {
	skip?: number;
	limit?: number;
	companyId?: string;
	yearly?: number;
	startYear?: number;
	endYear?: number;
}

interface EditTaxData {
	obligationType: "PLAN";
	profitTax: number;
	addIncomeTax: number;
	monthlyTax: number;
	valueAddedTax: number;
	exciseTax: number;
	dividendTax: number;
	otherTaxes: number;
	docFile?: string;
}

interface PostTaxData {
	companyId: string;
	obligationType: "PLAN";
	yearly: number;
	profitTax: number;
	addIncomeTax: number;
	monthlyTax: number;
	valueAddedTax: number;
	exciseTax: number;
	dividendTax: number;
	otherTaxes: number;
	docFile?: string;
}

interface DivDetailsParams {
	companyId?: string;
	yearly?: number;
}

interface PostDivPlanData {
	companyId: string;
	yearly: number;
	plannedDividend: number;
	totalPhase: number;
	docFile?: string;
}
interface PostDivPlanPay {
	dividendPlanId: string; // UUID
	dividend: number; // Dividend amount
	dividendDate: string; // Date in YYYY-MM-DD format
	docFile: string; // File name (string)
}

export const getTax = async (params?: BoardParams) => {
	const baseParams = {
		skip: params?.skip || 0,
		limit: params?.limit || 10,
		companyId: params?.companyId
			? params.companyId.replace(/^"(.+)"$/, "$1")
			: undefined,
		obligationType: params?.obligationType,
	};

	const configs = {
		params: {
			...baseParams,
			...(params?.yearly &&
				params.yearly !== 1111 && {
					yearly: params.yearly,
				}),
		},
	};

	try {
		const response = await axiosInstance.get(
			"/tax-obligations/company",
			configs,
		);
		console.log(response.data, "getTaxData44444444444444444");
		return response.data;
	} catch (error) {
		console.error("Error fetching board data:", error);
		throw error;
	}
};

export const getTaxSummary = async (
	params?: Record<string, string | number | undefined>,
) => {
	// const baseParams = {
	// 	skip: params?.skip || 0,
	// 	limit: params?.limit || 10,
	// 	companyId: params?.companyId
	// 		? params.companyId.replace(/^"(.+)"$/, "$1")
	// 		: undefined,
	// 	obligationType: params?.obligationType,
	// 	startYear: params?.startYear,
	// 	endYear: params?.endYear,
	// };

	try {
		const response = await axiosInstance.get("/tax-obligations/summary", {
			params,
		});
		console.log(response.data, "getTaxData44444444444444444");
		return response.data;
	} catch (error) {
		console.error("Error fetching board data:", error);
		throw error;
	}
};

export const getTaxDetails = async (params?: taxParamsDetails) => {
	const baseParams = {
		companyId: params?.companyId
			? params.companyId.replace(/^"(.+)"$/, "$1")
			: undefined,
		obligationType: params?.obligationType,
	};

	const configs = {
		params: params?.yearly
			? { ...baseParams, yearly: params.yearly }
			: baseParams,
	};

	try {
		const response = await axiosInstance.get(
			"/tax-obligations/report",
			configs,
		);
		console.log(response.data, "getTaxData44444444444444444");
		return response.data;
	} catch (error) {
		console.error("Error fetching board data:", error);
		throw error;
	}
};
export const getDividends = async (
	params?: Record<string, string | number | undefined>,
) => {
	try {
		const response = await axiosInstance.get("/dividends/plans/company", {
			params,
		});
		// console.log(response.data, "getDividendsData2222222222222222");
		return response.data;
	} catch (error) {
		console.error("Error fetching board data:", error);
		throw error;
	}
};

export const getDivDetails = async (id: string) => {
	// Remove any quotes from the id
	const cleanedId = id?.replace(/^"(.+)"$/, "$1");
	try {
		// Remove the extra quote that was in the URL
		const response = await axiosInstance.get(`/dividends/plans/${cleanedId}`);
		console.log("Dividend Details Response:", response.data); // Add logging
		return response.data;
	} catch (error) {
		console.error("Error fetching dividend plans:", error);
		throw error;
	}
};
// PUT data to dividends/plans/:id
export const editDividends = async (id: string, data: PostDivPlanData) => {
	const cleanedId = id?.replace(/^"(.+)"$/, "$1");
	try {
		const response = await axiosInstance.put(
			`/dividends/plans/${cleanedId}`,
			data,
		);
		console.log("Dividend Details Response:", response.data); // Add logging
		return response.data;
	} catch (error) {
		console.error("Error fetching dividend plans:", error);
		throw error;
	}
};

interface Detailsed {
	skip?: number;
	limit?: number;
	dividendPlanId?: string;
}
export const getDivDetailsed = async (params?: Detailsed) => {
	// Remove any quotes from the id

	const configs = {
		params: {
			skip: params?.skip || 0,
			limit: params?.limit || 10,
			dividendPlanId: params?.dividendPlanId
				? params.dividendPlanId.replace(/^"(.+)"$/, "$1")
				: undefined,
		},
	};
	console.log(configs, "configstttttttttttt");
	try {
		// Remove the extra quote that was in the URL
		const response = await axiosInstance.get("/dividends/executions", configs);
		// console.log("Dividend Details Response:", response.data); // Add logging
		return response.data;
	} catch (error) {
		console.error("Error fetching dividend plans:", error);
		throw error;
	}
};

export const editTax = async (id: string, data: EditTaxData) => {
	try {
		const response = await axiosInstance.put(`/tax-obligations/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error updating tax data:", error);
		throw error;
	}
};

export const postTax = async (data: PostTaxData) => {
	try {
		const response = await axiosInstance.post("/tax-obligations/plan", data);
		return response.data;
	} catch (error) {
		console.error("Error posting tax data:", error);
		throw error;
	}
};

export const postTaxExecution = async (data: PostTaxData) => {
	try {
		const response = await axiosInstance.post(
			"/tax-obligations/execution",
			data,
		);
		return response.data;
	} catch (error) {
		console.error("Error posting tax data:", error);
		throw error;
	}
};

export const postDivPlans = async (data: PostDivPlanData) => {
	try {
		const response = await axiosInstance.post("/dividends/plans", data);
		return response.data;
	} catch (error) {
		console.error("Error posting dividend plan:", error);
		throw error;
	}
};
export const postDivPay = async (data: {
	dividendPlanId: string;
	dividend: number;
	dividendDate: string;
	docFile: string;
}) => {
	try {
		const response = await axiosInstance.post("/dividends/executions", data);
		return response.data;
	} catch (error) {
		console.error("Error posting dividend payment:", error);
		throw error;
	}
};
